import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

function Privacy() {
  const { t } = useLanguage();
  return (
    <section className="page-section">
      <article className="shell legal-page">
        <p className="eyebrow">{t.privacyPage.eyebrow}</p>
        <h1>{t.privacyPage.title}</h1>
        <p>{t.privacyPage.intro}</p>
        <h2>{t.privacyPage.dataTitle}</h2>
        <p>{t.privacyPage.dataText}</p>
        <h2>{t.privacyPage.purposeTitle}</h2>
        <p>{t.privacyPage.purposeText}</p>
        <h2>{t.privacyPage.termTitle}</h2>
        <p>{t.privacyPage.termText}</p>
        <Link to="/contacts" className="button button--secondary">{t.privacyPage.back}</Link>
      </article>
    </section>
  );
}

export default Privacy;
